import {
	Table, Row, Col, Button, Select, Badge, Tooltip, message, Spin,
	Form,
	Modal,
} from "antd";
import { EditOutlined, EyeOutlined, PrinterOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { useState, useEffect, useCallback, useMemo } from "react";
import styled from "styled-components";
import { useBilling } from "context/BillingContext";
import moment from "moment";
import { CALL_API, CALL_FEATCH_API } from "common/API";
import { ReactComponent as Editicon } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as TrashDelete } from "../../assets/Trash_Full.svg";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { ViewClaims } from "pages/Engagement/Billing/ViewClaims";
import { ViewTimelogs } from "./ViewTimelogs";
import { useSelector } from "react-redux";
import { getUserList } from "redux/selectors";
import clientImage from "../../assets/clientBillingimg.png";
// FIX 9: import currencySymbolMap from constants
import { currencySymbolMap } from "common/Constants";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import {
	HistoryOutlined,
	CalendarOutlined,
} from "@ant-design/icons";

const greenBtn = {
	background: "#00685F",
	border: "none",
	borderRadius: 2,
	color: "#ffffff !important",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	fontWeight: 500,
	width: "150px",
};
const markaspaidsendbtn = {
	background: "#deefee",
	border: "none",
	borderRadius: 2,
	color: "#00685F",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	fontWeight: 500,
	width: "100px",
};

const StyledRow = styled(Row)`
	.btn-color-bill{
		color: #ffffff !important;
	}
`;

const StyledTable = styled(Table)`
  padding-top: 10px;
  table {
    width: 100% !important;
    border: 1px solid #ccc;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    color: #333;
    font-size: 14px;
  }
  .ant-table-row:nth-child(even) {
    background-color: #fafafa;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: #333;
    white-space: nowrap;
    padding: 12px 16px !important;
    height: 48px !important;
  }
  .ant-table-tbody .ant-table-cell {
    padding: 12px 16px !important;
    height: 48px !important;
  }
  .ant-table-tbody > tr:hover > td {
    background-color: #fafafa !important;
  }
  .ant-select-selector {
    min-width: 150px;
  }
  .ant-table-tbody > tr {
    cursor: pointer;
  }
  .ant-table-tbody > tr .action-icons {
    display: flex;
    gap: 8px;
    align-items: center;
    opacity: 0;
    transition: opacity 0.2s ease;
  }
  .ant-table-tbody > tr:hover .action-icons {
    opacity: 1;
  }
  .btn-color{
	color: #00685F !important;
	border-radius: "4px",
	padding: "4px",

  }
`;

const StyledModal = styled(Modal)`
  .ant-modal-content { border-radius: 12px; }
`;

const InvoiceModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 16px;
    padding: 0;
    overflow: hidden;
  }
  .ant-modal-body {
    padding: 0;
  }
  .ant-modal-close {
    top: 16px;
    right: 16px;
  }
`;

const InvoiceWrapper = styled.div`
  color: #1a1a1a;
  background: #fff;
  padding: 36px 40px 32px;
  max-height: 85vh;
  overflow-y: auto;
`;

const InvoiceHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 24px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 28px;
`;

const LogoBox = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px;
`;

const OrgName = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: #041053;
`;

const OrgSub = styled.div`
  font-size: 12px;
  color: #6b7280;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-top: 2px;
`;

const MetaGrid = styled.div`
  text-align: right;
  font-size: 13px;
  line-height: 1.8;
  color: #374151;
  strong { color: #111; }
`;

const SectionDivider = styled.div`
  border-top: 1px solid #e5e7eb;
  margin: 24px 0;
`;

const TwoCol = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 32px;
  margin-bottom: 24px;
`;

const ClientSection = styled.div`
  flex: 1;
`;

const SectionLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin-bottom: 8px;
`;

const ClientName = styled.div`
  font-size: 17px;
  font-weight: 700;
  color: #111;
  margin-bottom: 4px;
`;

const ClientAddress = styled.div`
  font-size: 13px;
  color: #374151;
  line-height: 1.7;
`;

const ContactPerson = styled.div`
  text-align: right;
`;

const ContactName = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: #111;
  margin-bottom: 4px;
`;

const CurrencyNote = styled.div`
  font-size: 13px;
  color: #374151;
  strong { color: #111; }
`;

const DescriptionBox = styled.div`
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px 20px;
  font-size: 14px;
  color: #374151;
  margin-bottom: 28px;
  min-height: 56px;
`;

const DescLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin-bottom: 10px;
`;

const StaffFeeGrid = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 40px;
  margin-bottom: 28px;
`;

const StaffSection = styled.div`
  flex: 1;
`;

const AttorneyLabel = styled.div`
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 3px;
`;

const AttorneyName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #111;
`;

const FeeTable = styled.div`
  flex: 1;
  max-width: 340px;
`;

const FeeRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #374151;
  padding: 5px 0;
  border-bottom: ${p => p.$last ? "none" : "1px solid #f3f4f6"};
`;

const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 700;
  color: #111;
  padding: 12px 0 4px;
  border-top: 2px solid #e5e7eb;
  margin-top: 4px;
  span:last-child { color: #1A227F; }
`;

const CertText = styled.div`
  font-size: 12px;
  color: #6b7280;
  margin: 20px 0 24px;
  line-height: 1.6;
`;

const ApprovalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 28px;
`;

const ApprovalBlock = styled.div``;
const ApprovalLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin-bottom: 4px;
`;
const ApprovalValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #111;
`;

const PrintBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 0 auto;
  padding: 11px 48px;
  background: #c2fae5;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #0d3d2a;
  cursor: pointer;
  transition: background 0.15s;
  &:hover { background: #a8f0d0; }
`;

const CancelBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 22px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid #d9d9d9;
  background: #ffffff;
  color: #333;
  transition: all 0.15s;
  &:hover { background: #f5f5f5; }
`;

const Yesbtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 22px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  border: none;
  background: #c2fae5;
  color: #131111;
  transition: all 0.15s;
  &:hover { background: #a8f0d0; }
`;

const BillInvoiceModal = ({ visible, onClose, billingId, clientId, getUserName, matterData, taxRate }) => {
	const [invoiceData, setInvoiceData] = useState(null);
	const [clientRes, setClientRes] = useState(null);
	const [loadingInvoice, setLoadingInvoice] = useState(false);

	useEffect(() => {
		if (!visible || !billingId || !clientId) return;
		setLoadingInvoice(true);
		setInvoiceData(null);
		setClientRes(null);
		CALL_FEATCH_API(
			`insyts/billing?billingid=${billingId}&clientid=${clientId}`,
			"get"
		)
			.then((res) => {
				const dataArr = res?.response?.data ?? res?.data ?? [];
				const bill = Array.isArray(dataArr) ? dataArr[0] : dataArr;
				const client = res?.response?.clientRes ?? null;
				setInvoiceData(bill);
				setClientRes(client);
			})
			.catch(() => message.error("Failed to load invoice details."))
			.finally(() => setLoadingInvoice(false));
	}, [visible, billingId, clientId]);

	const handlePrint = () => window.print();

	const d = invoiceData;
	const c = clientRes;
	const fees = Number(d?.billingfee || 0);

	const disbursement = (d?.claims || []).reduce((sum, cl) => {
		if ((cl?.type || "").toLowerCase() === "subcontract") return sum;
		return sum + Number(cl?.amount || 0);
	}, 0);

	const taxPercentage = d?.statusname === "Pending" ? Number(taxRate) : Number(d?.tax) || 0;

	const vatdisbursement = (d?.claims || []).reduce((sum, cl) => {
		if ((cl?.type || "").toLowerCase() === "subcontract") return sum;
		if (cl?.taxtype !== "VAT") return sum;
		const amount = Number(cl?.amount || 0);
		return sum + (amount * taxPercentage) / 100;
	}, 0);

	const subcontract = (d?.claims || []).reduce((sum, cl) => {
		if ((cl?.type || "").toLowerCase() !== "subcontract") return sum;
		return sum + Number(cl?.amount || 0);
	}, 0);

	const vatsubcontract = (d?.claims || []).reduce((sum, cl) => {
		if ((cl?.type || "").toLowerCase() !== "subcontract") return sum;
		if (cl?.taxtype !== "VAT") return sum;
		const amount = Number(cl?.amount || 0);
		return sum + (amount * taxPercentage) / 100;
	}, 0);

	const vatRate = d?.vat && d.vat.trim().toUpperCase() === "VAT" ? taxPercentage : 0;
	const vatAmount = ((fees * vatRate) / 100) + vatdisbursement + vatsubcontract;
	const total = fees + disbursement + subcontract + vatAmount;
	const currency = d?.currency || "USD";

	const currencySymbol = currencySymbolMap[currency] || currency;

	const fmt = (n) => Number(n || 0).toFixed(2);

	// FIX 1: include city, state/province, pin in address
	const addressParts = [
		c?.registeredaddress,
		c?.city,
		c?.state || c?.province,
		c?.bdo_pin || c?.pin || c?.zipcode,
		c?.country,
	].filter(Boolean).join(", ");

	const approvedBy = d?.billingapprovedby ? getUserName(d.billingapprovedby) : "—";
	const approvedDate = d?.billingapproveddate
		? moment(d.billingapproveddate).format("DD MMM YYYY")
		: d?.billingdate
			? moment(d.billingdate).format("DD MMM YYYY")
			: "—";

	return (
		<InvoiceModal
			open={visible}
			onCancel={onClose}
			footer={null}
			width={850}
			centered
			destroyOnClose
		>
			<Spin spinning={loadingInvoice}>
				{d ? (
					<InvoiceWrapper>
						<InvoiceHeader>
							<LogoBox>
								<img src={clientImage} alt="client logo" style={{ width: 80, height: 80, borderRadius: 8, objectFit: "cover", flexShrink: 0 }} />
								<div>
									<OrgName>{d.mattername || "Synergy Pvt Ltd"}</OrgName>
									<OrgSub>{c?.managingoffice || d.managingoffice || "—"}</OrgSub>
								</div>
							</LogoBox>
							<MetaGrid>
								<div>
									<strong>Date:</strong>{" "}
									{d.billingdate ? moment(d.billingdate).format("DD MMM YYYY") : "—"}
								</div>
								<div><strong>Matter ID:</strong> {d.matterid || "—"}</div>
								<div><strong>Billing ID:</strong> {d.billingid || billingId}</div>
							</MetaGrid>
						</InvoiceHeader>

						<TwoCol>
							<ClientSection>
								<SectionLabel>Client Information</SectionLabel>
								<ClientName>{d.clientname || c?.clientname || "—"}</ClientName>
								{/* FIX 1: full address with city, state/province, pin */}
								<ClientAddress>
									{addressParts && (
										<ClientAddress>
											{addressParts.split("\n").map((line, i) => (
												<span key={i}>{line}<br /></span>
											))}
										</ClientAddress>
									)}
								</ClientAddress>
							</ClientSection>
							<ContactPerson>
								<SectionLabel>Contact Person</SectionLabel>
								<ContactName>{d.contactperson || c?.primarycontactperson || "—"}</ContactName>
								<CurrencyNote>Currency: <strong>{currency === "USD" ? "US Dollar" : currency}</strong></CurrencyNote>
							</ContactPerson>
						</TwoCol>

						<DescLabel>Description of Services Rendered</DescLabel>
						<DescriptionBox>{d.description || "—"}</DescriptionBox>

						<StaffFeeGrid>
							<StaffSection>
								<SectionLabel>Staff Assignment</SectionLabel>
								<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<div>
										<AttorneyLabel>Lead Attorney</AttorneyLabel>
										{/* FIX 2: resolve lead attorney name */}
										<AttorneyName>
											{d.leadattorney ? getUserName(d.leadattorney) : "—"}
										</AttorneyName>
									</div>
									<div className="me-5">
										<AttorneyLabel>Referring Attorney</AttorneyLabel>
										{/* FIX 2: resolve referring attorney name */}
										<AttorneyName>
											{d.referringattorney ? getUserName(d.referringattorney) : "—"}
										</AttorneyName>
									</div>
								</div>
							</StaffSection>

							<FeeTable>
								<FeeRow>
									<span>Fees</span>
									<span>{currencySymbol}{fmt(fees)}</span>
								</FeeRow>
								<FeeRow>
									<span>Disbursement (Claims)</span>
									<span>{currencySymbol}{fmt(disbursement)}</span>
								</FeeRow>
								{/* FIX 4: subcontract summed from claims where type === "subcontract" */}
								<FeeRow>
									<span>Subcontract (Claims)</span>
									<span>{currencySymbol}{fmt(subcontract)}</span>
								</FeeRow>
								{/* FIX 3: VAT rate only 16% when vat === "VAT", else 0% */}
								<FeeRow $last>
									<span>VAT - {taxPercentage}%</span>
									<span>{currencySymbol}{fmt(vatAmount)}</span>
								</FeeRow>
								<TotalRow>
									<span>TOTAL ({currency})</span>
									{/* FIX 9: currency symbol in total */}
									<span>{currencySymbol}{fmt(total)}</span>
								</TotalRow>
							</FeeTable>
						</StaffFeeGrid>

						<SectionDivider />

						<CertText>
							I, certify that the above amount billed is in accordance with the matter and/or the assignment has been completed at client satisfaction.
						</CertText>

						<ApprovalRow>
							<ApprovalBlock>
								<ApprovalLabel>Approved By</ApprovalLabel>
								<ApprovalValue>{approvedBy}</ApprovalValue>
							</ApprovalBlock>
							<ApprovalBlock style={{ textAlign: "right" }}>
								<ApprovalLabel>Signature / Date</ApprovalLabel>
								<ApprovalValue>{approvedDate}</ApprovalValue>
							</ApprovalBlock>
						</ApprovalRow>

						<PrintBtn onClick={handlePrint}>
							<PrinterOutlined style={{ fontSize: 16 }} />
							Print Invoice
						</PrintBtn>
					</InvoiceWrapper>
				) : !loadingInvoice ? (
					<InvoiceWrapper>
						<div style={{ textAlign: "center", color: "#aaa", padding: "40px 0" }}>
							No invoice data available.
						</div>
					</InvoiceWrapper>
				) : (
					<InvoiceWrapper style={{ minHeight: 300 }} />
				)}
			</Spin>
		</InvoiceModal>
	);
};

const getCurrencySymbol = (currency) => {
	return currencySymbolMap[currency] ?? currency ?? "";
};

const formatDate = (dateStr) => {
	if (!dateStr) return "–";
	return moment(dateStr).format("DD MMM YYYY");
};

const HistoryTable = styled.table`
	width: 100%;
	border-collapse: collapse;
  `;

const HistoryTh = styled.th`
	text-align: left;
	padding: 10px;
	background: #f9fafb;
	border-bottom: 1px solid #e5e7eb;
  `;

const HistoryTd = styled.td`
	padding: 10px;
	border-bottom: 1px solid #f3f4f6;
  `;

/* ═══════════════════════════════════════════════════════
PAYMENT HISTORY MODAL  (standalone, reusable)
═══════════════════════════════════════════════════════ */

function PaymentHistoryModal({ record, open, onClose }) {
	const [historyData, setHistoryData] = useState([]);
	const [historyLoading, setHistoryLoading] = useState(false);

	const displayCurrency = record?.currency ?? "";
	const displayCurrencySymbol = getCurrencySymbol(displayCurrency);

	useEffect(() => {
		if (!open || !record) return;
		const fetchHistory = async () => {
			setHistoryLoading(true);
			setHistoryData([]);
			try {
				const fundId = record?.fundid || record?.id || "";
				const billingId = record?.billingid || record?.billId || "";

				let endpoint = "";
				if (billingId) {
					// billing-module path — try billing history first
					endpoint = `insyts/billing/getbillinghistory?billingid=${billingId}`;
				} else if (fundId) {
					endpoint = `insyts-legal/getfundrequesthistory?fundid=${fundId}`;
				}

				if (!endpoint) {
					message.error("No valid history source found");
					return;
				}

				const res = await CALL_FEATCH_API(endpoint, "GET");
				const rows =
					res?.response?.data ??
					res?.response ??
					res?.data ??
					[];
				setHistoryData(Array.isArray(rows) ? rows : []);
			} catch (err) {
				console.error("Error fetching payment history:", err);
				message.error("Failed to load payment history.");
			} finally {
				setHistoryLoading(false);
			}
		};
		fetchHistory();
	}, [open, record]);

	const totalPaidSoFar = useMemo(() => {
		if (!historyData.length) return null;
		return historyData.reduce(
			(sum, row) => sum + parseFloat(row.AmountMarkedasPaid || row.amountpaid || row.amount || 0),
			0
		);
	}, [historyData]);

	const requestedAmount =
		record?.requestamount || record?.amount || "–";

	return (
		<Modal
			title={null}
			open={open}
			onCancel={onClose}
			footer={null}
			width={760}
			centered
			destroyOnClose
		>
			<div style={{ padding: "4px 0 8px" }}>
				{/* Header row */}
				<div style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					marginBottom: 16,
					paddingRight: 32,
				}}>
					<span style={{ fontSize: 14, fontWeight: 700, color: "#111827", flexShrink: 0 }}>
						Payment History
					</span>
					<span style={{ fontSize: 14, color: "#374151", marginLeft: 16 }}>
						Amount requested initially:{" "}
						<span style={{ color: "#0d9488", fontWeight: 700 }}>
							{displayCurrencySymbol}{requestedAmount}
						</span>
					</span>
				</div>

				{historyLoading ? (
					<div style={{ textAlign: "center", padding: "40px 0" }}>
						<Spin size="default" />
					</div>
				) : historyData.length === 0 ? (
					<div style={{ textAlign: "center", padding: "32px 0", color: "#9ca3af", fontSize: 14 }}>
						No payment history found.
					</div>
				) : (
					<>
						<HistoryTable>
							<thead>
								<tr>
									<HistoryTh>S.No</HistoryTh>
									<HistoryTh>Amount Marked as Paid</HistoryTh>
									<HistoryTh>Source</HistoryTh>
									<HistoryTh>Destination</HistoryTh>
									<HistoryTh>Marked on</HistoryTh>
									<HistoryTh>Balance</HistoryTh>
								</tr>
							</thead>
							<tbody>
								{historyData.map((row, idx) => (
									<tr key={row.id || row.historyid || idx}>
										<HistoryTd>{idx + 1}</HistoryTd>
										<HistoryTd>
											{getCurrencySymbol(row.currency || displayCurrency)}
											{row.AmountMarkedasPaid ?? row.amountpaid ?? row.amount ?? "–"}
										</HistoryTd>
										<HistoryTd>{row.Source || row.source || row.sourceaccountname || "–"}</HistoryTd>
										<HistoryTd>{row.Destination || row.destination || row.destinationaccountname || "–"}</HistoryTd>
										<HistoryTd>
											<span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
												<CalendarOutlined style={{ color: "#9ca3af" }} />
												{formatDate(row.MarkedOn || row.paymentdate || row.markedon || row.createdat)}
											</span>
										</HistoryTd>
										<HistoryTd>
											{row.Balance !== undefined && row.Balance !== null
												? `${getCurrencySymbol(row.currency || displayCurrency)}${row.Balance}`
												: row.balance !== undefined && row.balance !== null
													? `${getCurrencySymbol(row.currency || displayCurrency)}${row.balance}`
													: "–"}
										</HistoryTd>
									</tr>
								))}
							</tbody>
						</HistoryTable>

						{totalPaidSoFar !== null && (
							<div style={{
								display: "flex",
								justifyContent: "flex-end",
								marginTop: 12,
								paddingTop: 10,
								borderTop: "1px solid #f3f4f6",
								fontSize: 14,
								color: "#374151",
							}}>
								Total paid so far:{" "}
								<span style={{ color: "#0d9488", fontWeight: 700, marginLeft: 6 }}>
									{displayCurrencySymbol}{totalPaidSoFar}
								</span>
							</div>
						)}
					</>
				)}
			</div>
		</Modal>
	);
}

const Billing = ({ matterId, matterData }) => {
	const history = useHistory();
	const [hoveredRow, setHoveredRow] = useState(null);
	const [tableData, setTableData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [lastEvaluatedKey, setLastEvaluatedKey] = useState(0);
	const [hasMore, setHasMore] = useState(true);
	const [filterState, setFilterState] = useState({
		submittedBy: [],
		status: [],
		taxType: [],
	});
	const [viewClaimsRecord, setViewClaimsRecord] = useState(null);
	const [viewTimelogRecord, setViewTimelogRecord] = useState(null);
	const [deleteModal, setDeleteModal] = useState(false);
	const [pendingDeleteRecord, setPendingDeleteRecord] = useState(null);
	const [billingData, setBillingData] = useState([]);
	const [invoiceModalVisible, setInvoiceModalVisible] = useState(false);
	const [selectedInvoiceRecord, setSelectedInvoiceRecord] = useState(null);
	const [historyRecord, setHistoryRecord] = useState(null);
	const [historyModalOpen, setHistoryModalOpen] = useState(false);

	const openHistory = (record) => {
		setHistoryRecord(record);
		setHistoryModalOpen(true);
	};

	const closeHistory = () => {
		setHistoryModalOpen(false);
		setHistoryRecord(null);
	};

	const userList = useSelector(getUserList);
	const [form] = Form.useForm();
	const { removeBill } = useBilling();

	const getUserName = (userId) => {
		const user = userList?.find(
			(u) => u.userid === userId || u.email === userId
		);
		return user?.name || user?.username || user?.fullname || userId || "—";
	};

	const { data: billingentity } = useFetch(queryKeys.getBillingEntityList.key, queryKeys.getBillingEntityList.url);
	const taxRate = billingentity?.response?.data?.find(be => be.id === matterData?.financial_resourcePlan?.billingEntityId)?.tax || 0;

	const fetchBills = useCallback(async (key = 0, append = false, filters = {}) => {
		if (!matterId) return;
		setLoading(true);
		try {
			const params = new URLSearchParams({
				matterid: matterId,
				lastEvaluatedKey: String(key),
			});

			if (filters.submittedBy?.length) filters.submittedBy.forEach((v) => params.append("submittedby", v));
			if (filters.status?.length) filters.status.forEach((v) => params.append("status", v));
			if (filters.taxType?.length) filters.taxType.forEach((v) => params.append("taxtype", v));

			const res = await CALL_API(`insyts/billing?${params.toString()}`, "get");

			const raw = res?.items ?? res?.response?.items ?? res?.response?.data ?? [];
			setBillingData(raw);
			const nextKey = res?.lastEvaluatedKey ?? res?.response?.lastEvaluatedKey ?? null;

			const mapped = (Array.isArray(raw) ? raw : []).map((bill) => {
				const claimsArr = Array.isArray(bill?.claims) ? bill.claims : [];
				const timelogArr = Array.isArray(bill?.timelog) ? bill.timelog : [];

				// FIX 7: normalize status — map "pending" API value to display label
				const rawStatus = (bill?.statusname ?? bill?.status ?? "pending").toLowerCase();
				const normalizedStatus =
					bill?.paidstatus === "1" || bill?.paidstatus === true
						? "paid"
						: rawStatus;

				// FIX 8: compute total amount (fees + claims + VAT)
				const fees = Number(bill?.billingfee || 0);

				const taxPercentage = bill?.statusname === "Pending" ? Number(taxRate) : Number(bill?.tax) || 0;
				const disbursement = (claimsArr || []).reduce((sum, cl) => {
					if ((cl?.type || "").toLowerCase() === "subcontract") return sum;
					return sum + Number(cl?.amount || 0);
				}, 0);

				const vatdisbursement = (claimsArr || []).reduce((sum, cl) => {
					if ((cl?.type || "").toLowerCase() === "subcontract") return sum;
					if (cl?.taxtype !== "VAT") return sum;
					const amount = Number(cl?.amount || 0);
					return sum + (amount * taxPercentage) / 100;
				}, 0);

				const subcontract = (claimsArr || []).reduce((sum, cl) => {
					if ((cl?.type || "").toLowerCase() !== "subcontract") return sum;
					return sum + Number(cl?.amount || 0);
				}, 0);

				const vatsubcontract = (claimsArr || []).reduce((sum, cl) => {
					if ((cl?.type || "").toLowerCase() !== "subcontract") return sum;
					if (cl?.taxtype !== "VAT") return sum;
					const amount = Number(cl?.amount || 0);
					return sum + (amount * taxPercentage) / 100;
				}, 0);

				const vatRate = bill?.vat && bill.vat.trim().toUpperCase() === "VAT" ? taxPercentage : 0;
				const vatAmount = ((fees * vatRate) / 100) + vatdisbursement + vatsubcontract;
				const totalAmount = fees + disbursement + subcontract + vatAmount;

				// FIX 9: resolve currency symbol for table display
				const currency = bill?.currency || "USD";
				const currencySymbol = currencySymbolMap[currency] || currency;

				return {
					key: bill?.billingid,
					submittedBy: bill?.userid || bill?.createdby || "—",
					date: bill?.billingdate ? moment(bill.billingdate).format("Do MMM, YYYY") : "—",
					billId: bill?.billingid || "—",
					clientId: bill?.clientid || matterData?.clientId || "",
					taxType: bill?.vat || "Non-VAT",
					// FIX 8 + FIX 9: show total with currency symbol
					amount: bill?.balance ? `${currencySymbol}${Number(bill?.balance).toFixed(2)}` : totalAmount > 0 ? `${currencySymbol}${bill?.amount?.toFixed(2)}` : "—",
					totalAmountRaw: totalAmount,
					currency,
					description: bill?.description || "",
					claims: claimsArr,
					claimsRaw: claimsArr,
					timeLog: timelogArr.length > 0
						? `${timelogArr.length} ${timelogArr.length === 1 ? "Log" : "Logs"}`
						: null,
					timelogRaw: timelogArr,
					status: normalizedStatus,
					actionBy: bill?.leadAttorney || bill?.approvedby || "",
					_raw: bill,
				};
			});

			setTableData((prev) => append ? [...prev, ...mapped] : mapped);
			setLastEvaluatedKey(nextKey ?? 0);
			setHasMore(!!nextKey);
		} catch (err) {
			console.error("Billing fetch error:", err);
			message.error("Failed to load bills.");
		} finally {
			setLoading(false);
		}
	}, [matterId]);

	useEffect(() => {
		fetchBills(0, false, {});
	}, [fetchBills]);

	const handleFilterChange = () => {
		const filters = {
			submittedBy: form.getFieldValue("submittedBy") || [],
			status: form.getFieldValue("status") || [],
			taxType: form.getFieldValue("taxType") || [],
		};
		fetchBills(0, false, filters);
	};

	const handleAddBills = () => {
		history.push({
			pathname: `${history.location.pathname}/addbills`,
			state: {
				clientId: matterData?.clientId, matterId, matterData, allBillingData: tableData?.map(b => ({
					billingid: b.key,
					claims: b.claimsRaw,
					timelog: b.timelogRaw,
				})),
			},
		});
	};

	const handleDeleteClick = (record) => {
		setPendingDeleteRecord(record);
		setDeleteModal(true);
	};

	const handleDeleteCancel = () => {
		setDeleteModal(false);
		setPendingDeleteRecord(null);
	};

	const handleDeleteConfirm = async () => {
		try {
			await CALL_API(
				`insyts/billing?matterid=${matterId}&billingid=${pendingDeleteRecord.billId}`,
				"delete"
			);
			removeBill(pendingDeleteRecord.billId);
			setTableData((prev) => prev.filter((r) => r.key !== pendingDeleteRecord.key));
			message.success("Deleted successfully");
		} catch {
			message.error("Delete failed");
		} finally {
			handleDeleteCancel();
		}
	};

	const handleRowClick = (record, e) => {
		if (e.target.closest(".action-icons") || e.target.closest("button") || e.target.closest(".claims-link") || e.target.closest(".timelog-link")) return;
		setSelectedInvoiceRecord(record);
		setInvoiceModalVisible(true);
	};

	// FIX 5: submitted by filter options use resolved names instead of raw IDs
	const submittedByOptions = [...new Map(
		tableData
			.filter((r) => r.submittedBy && r.submittedBy !== "—")
			.map((r) => [r.submittedBy, { label: getUserName(r.submittedBy), value: r.submittedBy }])
	).values()];

	const statusOptions = [...new Set(tableData.map((r) => r.status).filter(Boolean))]
		.map((v) => ({
			// FIX 7: display "Waiting for Approval" label in filter for pending status
			label: v === "pending" ? "Waiting for Approval" : v.charAt(0).toUpperCase() + v.slice(1),
			value: v,
		}));

	const taxTypeOptions = [...new Set(tableData.map((r) => r.taxType).filter(Boolean))]
		.map((v) => ({ label: v, value: v }));

	const columns = [
		{
			title: "Submitted by",
			dataIndex: "submittedBy",
			render: (text, record) => (
				<div>
					<div style={{ fontWeight: 500 }}>{getUserName(text)}</div>
					<small style={{ color: "#777" }}>{record.date}</small>
				</div>
			),
		},
		{
			title: "Bill ID",
			dataIndex: "billId",
			render: (val, record) =>
				val ? (
					<span
						style={{
							cursor: "pointer",
							fontWeight: 500,
						}}

					>
						{val}
					</span>
				) : (
					<span style={{ color: "#bbb" }}>—</span>
				),
		},
		{
			title: "Tax Type",
			dataIndex: "taxType",
		},
		{
			title: "Amount",
			dataIndex: "amount",
		},
		{
			title: "Claims",
			dataIndex: "claims",
			render: (val, record) =>
				val?.length ? (
					<span
						className="claims-link"
						style={{
							display: "inline-flex", alignItems: "center", color: "#1677ff",
							padding: "2px 10px", fontSize: 15, fontWeight: 500, cursor: "pointer"
						}}
						onClick={(e) => { e.stopPropagation(); setViewClaimsRecord(record); }}
					>
						{val.length} claims
					</span>
				) : <span style={{ color: "#bbb" }}>—</span>,
		},
		{
			title: "TimeLog",
			dataIndex: "timeLog",
			render: (val, record) =>
				val ? (
					<span
						className="timelog-link"
						style={{
							display: "inline-flex", alignItems: "center", color: "#1677ff",
							padding: "2px 10px", fontSize: 15, fontWeight: 500, cursor: "pointer"
						}}
						onClick={(e) => { e.stopPropagation(); setViewTimelogRecord(record); }}
					>
						{val}
					</span>
				) : <span style={{ color: "#bbb" }}>—</span>,
		},
		{
			title: "Status",
			dataIndex: "status",
			render: (_, record) => {
				const s = record.status;
				if (s === "paid")
					return <Badge status="success" text="Paid" />;
				if (s === "approved")
					return (
						<div>
							<div>Approved by: {getUserName(record.actionBy)}</div>
							<small style={{ color: "#777" }}>{record.date}</small>

						</div>
					);
				if (s === "declined")
					return (
						<div>
							<div>Declined by: {getUserName(record.actionBy)}</div>
							<small style={{ color: "#777" }}>{record.date}</small>
						</div>
					);
				// FIX 7: show "Waiting for Approval" for pending status
				return <span style={{ color: "#888" }}>Waiting for Approval</span>;
			},
		},
		{
			title: "",
			key: "actions",
			width: 220,
			render: (_, record) => {
				const status = record.status;
				const billingId = record.billId;
				return (
					<div className="action-icons" onClick={(e) => e.stopPropagation()}>

						{status === "pending" && (
							<>
								<EditOutlined
									onClick={() => history.push({
										pathname: `${history.location.pathname}/addbills`,
										state: { record: record._raw, matterId, matterData, source: "Billing Approvals", },
									})}
									style={{
										color: "#00685F",
										cursor: "pointer",
										background: "#deefee",
										padding: "2px",
										borderRadius: "4px",
										height: "25px",
										width: "25px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										fontSize: 18
									}}
								/>
								<TrashDelete
									onClick={() => handleDeleteClick(record)}
									style={{ cursor: "pointer", backgroundColor: "#deefee" }}
								/>
							</>
						)}

						{status === "waiting for approval" && (
							<>
								<EditOutlined
									onClick={() => history.push({
										pathname: `${history.location.pathname}/addbills`,
										state: { record: record._raw, matterId, matterData, source: "Billing Approvals", },
									})}
									style={{
										color: "#00685F",
										cursor: "pointer",
										background: "#deefee",
										padding: "2px",
										borderRadius: "4px",
										height: "25px",
										width: "25px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										fontSize: 18
									}}
								/>
								<TrashDelete
									onClick={() => handleDeleteClick(record)}
									style={{ cursor: "pointer", backgroundColor: "#C2FAE5" }}
								/>
							</>
						)}

						{status === "approved" && (
							<>
								<Button
									className="btn-color"
									size="small"
									style={markaspaidsendbtn}
									onClick={() =>
										history.push({
											pathname: `/matter-details/${matterData?.matterId}/markaspaid`,
											state: {
												matterData: matterData,
												amount: record,
												billingTabReturn: true,
												billingData: billingData?.find(b => b?.billingid === billingId)
											}
										})
									}
								>
									Mark as Paid
								</Button>
								<Button
									className="btn-color"
									size="small"
									style={markaspaidsendbtn}
									onClick={() =>
										history.push({
											pathname: `/matter-details/${matterId}/billingemail`,
											state: { matterData }
										})
									}
								>
									Send
								</Button>
								<HistoryOutlined
									onClick={() => openHistory(record)}
									style={{
										cursor: "pointer",
										fontSize: 18,
										color: "#00685F",
										backgroundColor: "#deefee",
										padding: "4px",
										borderRadius: "4px",
										marginLeft: 8,
									}}
								/>

							</>
						)}

						{status === "declined" && (
							<>
								<EditOutlined
									onClick={() => history.push({
										pathname: `${history.location.pathname}/addbills`,
										state: { record: record._raw, matterId, matterData, source: "Billing Approvals", },
									})}
									style={{
										color: "#00685F",
										cursor: "pointer",
										background: "#deefee",
										padding: "2px",
										borderRadius: "4px",
										height: "25px",
										width: "25px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										fontSize: 18
									}}
								/>
								<TrashDelete
									onClick={() => handleDeleteClick(record)}
									style={{ cursor: "pointer", backgroundColor: "#C2FAE5" }}
								/>
							</>
						)}

						{status === "paid" && (
							<>
								<HistoryOutlined
									onClick={() => openHistory(record)}
									style={{
										cursor: "pointer",
										fontSize: 18,
										color: "#00685F",
										backgroundColor: "#deefee",
										padding: "4px",
										borderRadius: "4px",
										marginLeft: 8,
									}}
								/>
								<span
									style={{
										display: "inline-flex",
										alignItems: "center",
										gap: 8,
										fontSize: 14,
										color: "#2f2f2f",
										fontWeight: 400,
									}}
								>
									<span
										style={{
											width: 14,
											height: 14,
											borderRadius: "50%",
											border: "3px solid #16c60c",
											background: "#fff",
											display: "inline-block",
											boxSizing: "border-box",
										}}
									/>
									Paid
								</span>

								<Button
									size="small"
									className="btn-color"
									style={markaspaidsendbtn}
									onClick={() =>
										history.push({
											pathname: `/matter-details/${matterId}/billingemail`,
											state: { matterData }
										})
									}
								>
									Send
								</Button>
							</>
						)}

					</div>
				);
			},
		},
	];



	return (
		<div style={{ padding: "28px 0" }}>
			<StyledRow justify="space-between" style={{ marginBottom: 8 }}>
				<Col><b>Total Bills: {tableData?.length}</b></Col>
				<Col>
					<Form form={form} layout="vertical">
						<div style={{ display: "flex", gap: 12, flexWrap: "wrap" }} >
							<div style={{ width: 176 }}>
								{/* FIX 5: submittedByOptions now use resolved names as labels */}
								<DropdownCheckBox
									name="submittedBy"
									label="Submitted by"
									options={submittedByOptions}
									form={form}
									handleFormChange={handleFilterChange}
								/>
							</div>
							<div style={{ width: 176 }}>
								{/* FIX 7: statusOptions show "Waiting for Approval" label */}
								<DropdownCheckBox
									name="status"
									label="Status"
									options={statusOptions}
									form={form}
									handleFormChange={handleFilterChange}
								/>
							</div>
							<div style={{ width: 176 }}>
								<DropdownCheckBox
									name="taxType"
									label="Tax Type"
									options={taxTypeOptions}
									form={form}
									handleFormChange={handleFilterChange}
								/>
							</div>
							<Button
								className="btn-color-bill"
								disabled={matterData?.pfaStatus === "Not Approved"
									|| matterData?.matterStatus === "Not Approved"
									|| matterData?.matterStatus === "Closed"}
								onClick={handleAddBills}
								style={{ ...greenBtn, padding: "12px 16px" }}
							>
								Add Bills
							</Button>
						</div>
					</Form>
				</Col>
			</StyledRow>

			<Spin spinning={loading}>
				<StyledTable
					columns={columns}
					dataSource={tableData}
					pagination={false}
					onRow={(record) => ({
						onMouseEnter: () => setHoveredRow(record.key),
						onMouseLeave: () => setHoveredRow(null),
						onClick: (e) => handleRowClick(record, e),
						style: { cursor: "pointer" },
					})}
					footer={hasMore ? () => (
						<div style={{ textAlign: "center", padding: "8px 0" }}>
							<Button
								onClick={() => fetchBills(lastEvaluatedKey, true, {
									submittedBy: form.getFieldValue("submittedBy") || [],
									status: form.getFieldValue("status") || [],
									taxType: form.getFieldValue("taxType") || [],
								})}
								loading={loading}
								style={greenBtn}
							>
								Load More
							</Button>
						</div>
					) : null}
				/>
			</Spin>

			<BillInvoiceModal
				visible={invoiceModalVisible}
				onClose={() => { setInvoiceModalVisible(false); setSelectedInvoiceRecord(null); }}
				billingId={selectedInvoiceRecord?.billId}
				clientId={selectedInvoiceRecord?.clientId || matterData?.clientId}
				getUserName={getUserName}
				matterData={matterData}
				taxRate={taxRate}
			/>

			<ViewClaims
				isModalVisible={!!viewClaimsRecord}
				setIsModalVisible={() => setViewClaimsRecord(null)}
				addClaims={viewClaimsRecord?.claimsRaw || []}
				setaddClaims={() => { }}
				claimsDataSource={viewClaimsRecord?.claimsRaw || []}
				isViewClims={true}
				viewClims={true}
				update={false}
				activeclaimsIds={[]}
			/>

			{/* FIX 6: spread flat timelog objects so all fields (including status) are preserved */}
			<ViewTimelogs
				isModalVisible={!!viewTimelogRecord}
				setIsModalVisible={() => setViewTimelogRecord(null)}
				addTimelogs={viewTimelogRecord?.timelogRaw || []}
				setAddTimelogs={() => { }}
				timelogsDataSource={
					(viewTimelogRecord?.timelogRaw || []).map((t) => {
						if (t?.timelogId && typeof t.timelogId === "object") {
							return { ...t.timelogId };
						}
						return { ...t };
					})
				}
				isViewTimelogs={true}
				viewTimelogs={true}
				update={false}
				activeTimelogIds={[]}
				matterid={matterId}
			/>

			<StyledModal
				open={deleteModal}
				onCancel={handleDeleteCancel}
				footer={null}
				width={500}
				closable={false}
				centered
				destroyOnClose
			>
				<div style={{ textAlign: "left", padding: "24px 16px 8px" }}>
					<p style={{ fontSize: 15, fontWeight: 500, color: "#111827", marginBottom: 32 }}>
						Are you sure you want to delete this Bill?
					</p>
					<div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }}>
						<CancelBtn onClick={handleDeleteCancel} style={{ width: 150, borderRadius: 10 }}>
							No
						</CancelBtn>
						<Yesbtn onClick={handleDeleteConfirm} style={{ width: 150 }}>
							Yes
						</Yesbtn>
					</div>
				</div>
			</StyledModal>
			<PaymentHistoryModal
				record={historyRecord}
				open={historyModalOpen}
				onClose={closeHistory}
			/>
		</div>
	);


};

export default Billing;